import React from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import { LocationItemProps } from './types/locationListingTypes';
import classnames from 'classnames';

const LocationItem = ({
  locationId,
  type,
  isActive,
  onClick,
  labelMilesAway,
  labelGetDirectionsBtn,
  labelCallUsBtn,

  labelLearnMoreBtn,
  locationData
}: LocationItemProps) => {
  const hasLobbyHours = locationData.lobbyHours?.length > 0;
  const hasAtmHours = locationData.atmHours?.length > 0;
  const hasDriveThruHours = locationData.driveThruHours?.length > 0;
  const hasVideoTellerHours = locationData.videoTellerHours?.length > 0;
  const hasDriveThruVideoTellerHours = locationData.driveThruVideoTellerHours?.length > 0;
  const hasServices = locationData.services?.length > 0;
  const hasProducts = locationData.products?.length > 0;

  const hasHours =
    hasLobbyHours ||
    hasAtmHours ||
    hasDriveThruHours ||
    hasVideoTellerHours ||
    hasDriveThruVideoTellerHours;
  const hasFeaturesAndServices = hasServices || hasProducts;
  const showAccordion = hasHours || hasFeaturesAndServices;

  const destinationUrl = `https://www.google.com/maps/dir/?api=1&destination=${locationData.address.latitude},${locationData.address.longitude}`;


  return (
    <div
      className={classnames('location-item', {
        'location-item--active': isActive
      })}
      onClick={() => onClick(locationId, true, true)}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          onClick(locationId, true, true);
        }
      }}
      tabIndex={0}
      id={locationId}
      role="button"
    >
      <div className="location-item__header">
        <div className="location-item__header-left">
          <h2 className="location-item__headline">
            {locationData.link ? (
              <a href={locationData.link} target="_blank">
                {locationData.name}
              </a>
            ) : (
              <span>{locationData.name}</span>
            )}
          </h2>
          <div className="location-item__distance-wrapper">
            <svg aria-hidden="true" focusable="false" className={`icon icon--location-${type}`}>
              <use xlinkHref="#icon-location-pin" href="#icon-location-pin"></use>
            </svg>
            <small>
              {locationData.distance || 0} {labelMilesAway}
            </small>
          </div>
        </div>

        <div className="location-item__header-right">
          {locationData.image && <img src={locationData.image} alt={locationData.name} />}
        </div>
      </div>

      <div className="location-item__content">
        <div className="location-item__address">
          <a href={destinationUrl} className='location-item__address__lines__link'>
            <div className="location-item__address__lines">

              <span>{locationData.address?.street}</span>
              <span>
                {locationData.address?.city}, {locationData.address?.state}
              </span>

            </div></a>

          {locationData.phone && (
            <a className="location-item__phone" href={`tel:${locationData.phone}`}>
              {locationData.phone}
            </a>
          )}
          <a className="btn btn--primary btn--outline" href={destinationUrl}>
            {labelGetDirectionsBtn}
          </a>

          {locationData.phone && (
            <a
              className="btn btn--primary btn--outline location-item__call-us"
              href={`tel:${locationData.phone}`}
            >
              {labelCallUsBtn}
            </a>
          )}
        </div>

        <div className="location-item__image">
          {locationData.image && <img src={locationData.image} alt={locationData.name} />}
        </div>
      </div>

      {showAccordion && (
        <Accordion.Root className="location-item__accordion" type="multiple">
          {hasHours && (
            <Accordion.Item className="location-item__accordion-item" value="item-1">
              <Accordion.Trigger className="location-item__accordion-trigger">
                <h3>{locationData.hourHeading}</h3>
                <svg aria-hidden="true" focusable="false">
                  <use xlinkHref="#icon-thin-plus" href="#icon-thin-plus"></use>
                </svg>
                <svg aria-hidden="true" focusable="false">
                  <use xlinkHref="#icon-thin-minus" href="#icon-thin-minus"></use>
                </svg>
              </Accordion.Trigger>
              <Accordion.Content className="location-item__accordion-content">
                <ul className="location-item__accordion-hours">
                  {hasLobbyHours && (
                    <li>
                      <h4>{locationData.lobbyHoursHeading}</h4>
                      <ul className="location-item__accordion-hours-list">
                        {locationData.lobbyHours?.map((hour, index) => (
                          <li key={index}>
                            <span dangerouslySetInnerHTML={{ __html: hour.day }} />
                            <span dangerouslySetInnerHTML={{ __html: hour.time }} />
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}

                  {hasAtmHours && (
                    <li>
                      <h4>{locationData.atmHeading}</h4>

                      <ul className="location-item__accordion-hours-list">
                        {locationData.atmHours?.map((hour, index) => (
                          <li key={index}>
                            <span dangerouslySetInnerHTML={{ __html: hour.day }} />
                            <span dangerouslySetInnerHTML={{ __html: hour.time }} />
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}

                  {hasDriveThruHours && (
                    <li>
                      <h4>{locationData.driveThruHeading}</h4>
                      <ul className="location-item__accordion-hours-list">
                        {locationData.driveThruHours?.map((hour, index) => (
                          <li key={index}>
                            <span dangerouslySetInnerHTML={{ __html: hour.day }} />
                            <span dangerouslySetInnerHTML={{ __html: hour.time }} />
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}

                  {hasVideoTellerHours && (
                    <li>
                      <h4>{locationData.videoTellerHeading}</h4>
                      <ul className="location-item__accordion-hours-list">
                        {locationData.videoTellerHours?.map((hour, index) => (
                          <li key={index}>
                            <span dangerouslySetInnerHTML={{ __html: hour.day }} />
                            <span dangerouslySetInnerHTML={{ __html: hour.time }} />
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}

                  {hasDriveThruVideoTellerHours && (
                    <li>
                      <h4>{locationData.driveThruVideoTellerHeading}</h4>
                      <ul className="location-item__accordion-hours-list">
                        {locationData.driveThruVideoTellerHours?.map((hour, index) => (
                          <li key={index}>
                            <span dangerouslySetInnerHTML={{ __html: hour.day }} />
                            <span dangerouslySetInnerHTML={{ __html: hour.time }} />
                          </li>
                        ))}
                      </ul>
                    </li>
                  )}
                </ul>
              </Accordion.Content>
            </Accordion.Item>
          )}

          {hasFeaturesAndServices && (
            <Accordion.Item className="location-item__accordion-item" value="item-2">
              <Accordion.Trigger className="location-item__accordion-trigger">
                <h3>{locationData.serviceHeading}</h3>
                <svg aria-hidden="true" focusable="false">
                  <use xlinkHref="#icon-thin-plus" href="#icon-thin-plus"></use>
                </svg>
                <svg aria-hidden="true" focusable="false">
                  <use xlinkHref="#icon-thin-minus" href="#icon-thin-minus"></use>
                </svg>
              </Accordion.Trigger>
              <Accordion.Content className="location-item__accordion-content">
                <ul className="location-item__accordion-features">
                  {locationData.services?.map((service, index) => <li key={index}>{service}</li>)}
                  {locationData.products?.map((product, index) => (
                    <li key={index}>
                      <a href={product.Url} target="_blank">
                        {product.Text}
                      </a>
                    </li>
                  ))}
                </ul>
              </Accordion.Content>
            </Accordion.Item>
          )}
        </Accordion.Root>
      )}

      {locationData.link && (
        <a href={locationData.link} className="link location-item__learn-more" target="_blank">
          <span className="link__label">{labelLearnMoreBtn}</span>
          <span className="icon  icon-size--16 ">
            <svg role="presentation">
              <use xlinkHref="#icon-arrow-right" />
            </svg>
          </span>
        </a>
      )}
    </div>
  );
};

export default LocationItem;
